export default __webpack_public_path__ + "aa76415ffe7a48ab92df4f17e7681b31.svg";